import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Col, Form, FormGroup, Panel} from 'react-bootstrap';
import {Field, reduxForm} from 'redux-form';
import {InputField} from './InputField';
import {Link} from 'react-router-dom'
import {validation} from '../validation';

const validate = validation({
    firstName: {
        required: true,
    },
    lastName: {
        required: true,
    },
    email: {
        required: true,
    },
});

@reduxForm({form: 'UserEdit', validate})
export default class UserEdit extends Component {
    static propTypes = {
        userId: PropTypes.string,
        usageLimitEditable: PropTypes.bool,
        initialValues: PropTypes.object, // this contains the actual data for this entity
        handleSubmit: PropTypes.func, // passed by redux-form
        onDeleteAccount: PropTypes.func,
        history: PropTypes.object,
        header: PropTypes.any,
    };

    render() {
        const {userId, history, handleSubmit, onDeleteAccount, usageLimitEditable} = this.props;
        const header = this.props.header || (
            <div className="edit-header">
                <ol className="breadcrumb">
                    <li><Link to="/admin/users">{'Users'}</Link></li>
                    <li className="active">{userId ? `Update #${userId}` : 'Create New'}</li>
                </ol>
                <div className="pull-right">
                    {userId && <Button bsSize="small" title="Delete" bsStyle="danger" onClick={() => onDeleteAccount(userId)}>
                        <i className="fa fa-remove"/>{' Delete'}
                    </Button>}
                </div>
            </div>
        );

        return (
            <Panel header={header}>
                <Form onSubmit={handleSubmit} style={{margin: 'auto', width: 600}} horizontal className="user-edit">
                    <Field type="text" name="firstName" component={InputField} label="First Name" required autoFocus/>
                    <Field type="text" name="lastName" component={InputField} label="Last Name" required/>
                    <Field type="text" name="email" component={InputField} label="Email" required autoComplete="off"/>
                    <Field type="password" name="password" component={InputField} label="Password" required autoComplete="off"/>
                    <Field type="password" name="confirmPassword" component={InputField} label="Confirm password" required autoComplete="off"/>
                    <Field type="text" name="usageLimit" component={InputField} label="Usage Limit" required autoComplete="off"
                           readOnly={usageLimitEditable}/>
                    <FormGroup>
                        <Col mdOffset={3} md={9}>
                                <Button type="submit" bsStyle="success">{userId ? 'Update' : 'Create'}</Button>
                                <Button bsStyle="link" title="Cancel and go back" onClick={() => history.goBack()}>{'Cancel'}</Button>
                        </Col>
                    </FormGroup>
                </Form>
            </Panel>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/UserEdit.js